// extracted by mini-css-extract-plugin
module.exports = {"form":"index1_form__3pHWO","title":"index1_title__2bGh2","form-control":"index1_form-control__LUtZk","button-lg":"index1_button-lg__1ISXE","error":"index1_error__CN1xx"};